import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ColorPicker.css';

class ColorPicker extends Component {
  constructor(props={hidePreview: false}) {
    super(props);
    let previewStyleDisplay = 'block';
    if(props.hidePreview) {
      previewStyleDisplay = 'none';
    }
    this.state = {
      paused: false,
      colorPickerHeight: 34,
      previewStyleDisplay: previewStyleDisplay
    };
    this.drawColorPicker = this.drawColorPicker.bind(this);
    this.pickColor = this.pickColor.bind(this);
    this.pauseTracking = this.pauseTracking.bind(this);
  }

  drawColorPicker() {
    let c = document.getElementById('color_picker');
    let ctx = c.getContext('2d');
    let colorPickerContainer = document.getElementById('color_picker_container');
    let colorPickerWidth = colorPickerContainer.offsetWidth;
    c.width = colorPickerWidth;
    let gradient = ctx.createLinearGradient(0,0,colorPickerWidth,0);
    gradient.addColorStop(0,"rgb(255,0,0)");
    gradient.addColorStop(0.166666666666666,"rgb(255,255,0)");
    gradient.addColorStop(0.333333333333333,"rgb(0,255,0)");
    gradient.addColorStop(0.5,"rgb(0,255,255)");
    gradient.addColorStop(0.666666666666666,"rgb(0,0,255)");
    gradient.addColorStop(0.844444444444444,"rgb(255,0,255)");
    gradient.addColorStop(1,"rgb(255,0,0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(0,0,colorPickerWidth,34);
    // Pretty sure this doesn't need state.
    this.setState({...this.state, color_preview_id: 'color_picker_preview', china: 'asdf'});
  }

  pickColor(event) {
    if(!this.state.paused) {
      let c = document.getElementById('color_picker');
      let rect = c.getBoundingClientRect();
      let x = event.clientX - rect.left;
      let y = event.clientY - rect.top;
      let ctx = c.getContext('2d');
      let pixel = ctx.getImageData(x,y,1,1);
      let data = pixel.data;
      let rgba = 'rgba(' + data[0] + ', ' + data[1] + ', ' + data[2] + ', ' + (data[3]/255) + ')';
      let color_preview_dom = document.getElementById('color_picker_preview');
      color_preview_dom.style.background = rgba;
      color_preview_dom.textContent = rgba;
      this.props.onPickColor(rgba);
    } else {
      console.log('china');
    }
  }

  pauseTracking(event) {
    this.setState({paused: !this.state.paused})
  }

  componentDidMount() {
    this.drawColorPicker();
    window.addEventListener('resize', this.drawColorPicker);
  }

  render() {
    return (
      <div id="color_picker_container">
        <div style={{display: this.state.previewStyleDisplay, height: 2}} className="color_picker_preview" id='color_picker_preview'>&nbsp;</div>
        <canvas onMouseMove={this.pickColor} onClick={this.pauseTracking} height={this.state.colorPickerHeight} className="color_picker img-responsive" id="color_picker"></canvas>
      </div>
    );
  }
}

ColorPicker.propTypes = {
  onPickColor: PropTypes.func.isRequired
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/ColorPicker/ColorPicker.js